//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Badge, { BadgeType } from '@components/atoms/badge/Badge';

export const AgentsBetaBadge = () => {
  return (
    <BadgeContainer>
      <Badge size='small' text='BETA' type={BadgeType.Secondary} />
    </BadgeContainer>
  );
};

const BadgeContainer = styled.div`
  margin-left: ${({ theme }) => theme.spacings[2]};
  display: inline-flex;
`;
